<template>
    <div class="left-box">
        <title1 title="考核指标" subTitle="Evaluation Index" />
        <div class="flex justify-between mt-40">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex flex1 flex-direction align-center target1">
                <img class="img mt-10" :src="require('@/assets/images/exposition/chd-bg-1.png')" alt="">
                <div class="num mt-10" v-if="item.overTenThousand">{{ item.number | overTenThousand }}</div>
                <div class="num mt-10" v-else>{{ item.number }}</div>
                <div class="label mt-10" v-html="item.label"></div>
            </div>
        </div>

        <div class="flex flex-wrap mt-70 justify-between">
            <div
                v-for="(item, i) in target2"
                :key="'target1' + i"
                class="flex align-center target2 width-50 mt-30">
                <div class="flex flex-direction align-center mr-15">
                    <img class="img" :src="require('@/assets/images/exposition/chd-bg-2.png')" alt="">
                </div>
                <div class="flex1">
                    <div class="label">{{ item.label }}</div>
                    <div class="num mt-15">{{ item.number }}</div>
                    <!-- <div class="flex justify-between">
                        <span>{{ item.tips }}</span>
                        <span>{{ item.ratio }}</span>
                    </div> -->
                </div>
            </div>
        </div>

        <title1 class="mt-80" type="2" title="运营业务收入" />
        <div class="box-1 mt-35">
            <myEchart
                v-if="operatingRevenueShow"
                :id="'operatingRevenue'"
                :options="operatingRevenueOptions" />
        </div>

        <title1 class="mt-80" type="2" title="日充换电次数" />
        <div class="box-1 mt-35">
            <myEchart
                v-if="dailyChargingShow"
                :id="'dailyCharging'"
                :options="dailyChargingOptions" />
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from '@/api/dataInterfaceApi'
import myEchart from './../charts/echarts'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart
    },
    data() {
        return {
            target1: [
                {
                    number: '',
                    label: '本月运营<br>收入(万元)',
                    overTenThousand: true
                },
                {
                    number: '',
                    label: '本月新增<br>站点(座)'
                },
                {
                    number: '',
                    label: '本月新增<br>入网车辆'
                },
            ],
            target2: [
                {
                    number: '',
                    label: '本月有效换电率(%)',
                    tips: '较上月',
                    // ratio: '1.00%'
                },
                {
                    number: '',
                    label: '本月客户满意度(%)',
                    tips: '较上月',
                    // ratio: '1.00%'
                },
                {
                    number: '',
                    label: '本月累计碳减排(cc)',
                    tips: '较上月',
                    // ratio: '1.00%'
                },
                {
                    number: '',
                    label: '安全运营天数(天)',
                    tips: '较上月',
                    // ratio: '1.00%'
                },
            ],
            operatingRevenueShow: false,
            operatingRevenueOptions: {},

            dailyChargingShow: false,
            dailyChargingOptions: {}
        }
    },
    methods: {
		getData(data) {
            console.log('snec充换电首页center-1')
            // 考核指标1
            this.kaohezhibiao1(data)
            // 考核指标2
            this.kaohezhibiao2(data)
            // 运营业务收入
            this.yunyingshouru(data)
            // 日充换电次数
            this.richonghuandiancishu(data)
        },
        // 考核指标1
        kaohezhibiao1(data) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-yunyingzhibiaoshouru' : 'TiDB-shengshiqu-yunyingzhibiaoshouru',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target1[0].number = data.Revenue
                this.target1[1].number = data.StationNum
                this.target1[2].number = data.VehicleAccess
			})
			.catch((err) => {
				console.log(err)
			})
        },

        // 考核指标2
        kaohezhibiao2(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-yunyingzhibiao-tanjianpai' : 'TiDB-shengshiqu-yunyingzhibiao-tanjianpai',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target2[0].number = data.EffectiveConversionRate
                this.target2[1].number = data.CustomerSatisfaction
                this.target2[2].number = data.carbonReduction
                this.target2[3].number = data.SafeDays 
			})
			.catch((err) => {
				console.log(err)
			})
		},

        // 运营业务收入
        yunyingshouru(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-shangyongchengyongyunyingyewushourutu' : 'TiDB-shengshiqu-shangyongchengyongyewutu',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push((parseFloat(item.IncomeVehicleCommercial || 0) / 10000).toFixed(2))
                    yData2.push((parseFloat(item.IncomeVehiclePassenger || 0) / 10000).toFixed(2))
                })
                this.operatingRevenueShow = false
                this.operatingRevenueOptions = {
                    title: {
                        text: '万元'
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '商用车',
                            type: 'bar',
                            data: yData1,
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 万元';
                                }
                            },
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(11, 185, 229, 0)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(14, 202, 250, 1)'
                                }])
							},
                        },
                        {
                            name: '乘用车',
                            type: 'bar',
                            data: yData2,
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 万元';
                                }
                            },
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(75, 244, 211, 0)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(20, 254, 208, 1)'
                                }])
							},
                        }
                    ]
                }
                this.operatingRevenueShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},

        // 日充换电次数
        richonghuandiancishu(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-rihuandiancishuqushi' : 'TiDB-shengshiqu-rihuandiancishu',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push(item.pass_num)
                    yData2.push(item.comm_num)
                })
                this.dailyChargingShow = false
                this.dailyChargingOptions = {
                    title: {
                        text: '    次'
                    },
                    color: ['#f2bd4c','#8bcfd0'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '商用车',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#FFCE51'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235, 190, 77, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235, 190, 76, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 次';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData1
                        },
                        {
                            name: '乘用车',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#8bcfd0'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(139, 207, 208, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(134, 201, 203, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 次';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData2
                        },
                    ]
                }
                this.dailyChargingShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>